<template>
  <div
    v-if="isOpen"
    id="modal"
    class="fixed z-40 top-0 left-0 right-0 bottom-0 duration-300 overflow-auto"
    style="background-color: rgba(0, 0, 0, .25)"
    @scroll="onScroll"
  >
    <transition name="fade">
      <div
        v-if="isOpen"
        class="w-full duration-300 opacity-100 flex items-center h-screen"
        :class="[getContainerWidth]"
      >
        <div class="relative bg-white shadow-2xl max-w-full m-auto flex flex-col" :class="[getWidth]">
          <div class="p-6 flex items-center justify-end">
            <button
              type="button"
              class="w-12 h-12 flex items-center justify-center border border-gray-400 text-gray-700"
              @click="close"
            >
              <span class="icon icon-close" />
            </button>
          </div>
          <div
            v-if="title"
            :class="headerClasses"
            class="flex-none"
          >
            <p class="text-h1 leading-none">
              {{ title }}
            </p>
            <slot name="header" />
          </div>
          <div :class="contentClasses" class="">
            <slot />
          </div>
          <div class="h-106px w-full flex-none bg-white">
            <slot name="footer" />
          </div>
          <div
            v-if="$slots.actions"
            :class="footerClasses"
          >
            <slot name="actions" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'default'
    },
    disableClickOutside: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    headerClasses: {
      type: String,
      default: 'border-b-2 border-blue-100 px-10 py-4 font-medium'
    },
    contentClasses: {
      type: String,
      default: 'text-sm flex flex-grow bg-gray-100'
    },
    footerClasses: {
      type: String,
      default: 'flex justify-between px-5 py-4 bg-gray-100'
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    getWidth () {
      return {
        'w-1/2': !this.small && !this.full && !this.large,
        'w-1/3': this.small,
        'w-2/3': this.large,
        'w-full h-screen overflow-hidden flex flex-col': this.full
      }
    },
    getContainerWidth () {
      return {
        'p-8' : !this.full
      }
    }
  },
  created () {
    this.$eventHub.$on(`modal:${this.name}:open`, () => {
      this.open()
    })
    this.$eventHub.$on(`modal:${this.name}:close`, () => {
      this.close()
    })
  },
  beforeDestroy () {
    this.$off([`modal:${this.name}:open`, `modal:${this.name}:close`])
  },
  methods: {
    open () {
      this.isOpen = true
      document.body.style.overflow = 'hidden'
    },
    close () {
      this.isOpen = false
      document.body.style.overflow = 'auto'
    },
    onClickOutsite () {
      if (!this.disableClickOutside) {
        this.close()
      }
    },
    onScroll (event) {
      this.$emit('modal-scroll', event)
    }
  }
}
</script>

<style scoped>
.fade-enter, .fade-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply opacity-0;
}
.modal-enter, .modal-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply transform scale-90 translate-y-6 opacity-0;
}
</style>
